import { DAY_MS } from '#shared';

import type { MaoCrewDuty } from '#entities';

export const getAircraftCrewDutyRanges = (crewDuties: MaoCrewDuty[]) => {
  const ranges: [number, number][] = [];
  const periodEnd = new Date().getTime() + DAY_MS;
  const sorted = crewDuties
    .filter(cd => cd.OnDutyDateTimeUnix < periodEnd)
    .sort((a, b) => a.OnDutyDateTimeUnix - b.OnDutyDateTimeUnix);
  sorted.forEach((cd, index, arr) => {
    const curStart = Math.max(cd.OnDutyDateTimeUnix, new Date().getTime());
    const curEnd = cd.OffDutyDateTimeUnix;
    const intersected = arr.filter(
      c =>
        c.Id !== cd.Id &&
        c.OnDutyDateTimeUnix < curEnd &&
        c.OffDutyDateTimeUnix > curStart,
    );
    if (!intersected.length) {
      return;
    }
    const prevRange = ranges.at(-1);

    const rangeStart = Math.max(
      Math.min(...intersected.map(c => c.OnDutyDateTimeUnix)),
      curStart,
    );
    const rangeEnd = Math.min(
      Math.max(...intersected.map(c => c.OffDutyDateTimeUnix)),
      curEnd,
    );

    if (prevRange && prevRange[1] >= rangeStart) {
      prevRange[1] = rangeEnd;
    } else {
      ranges.push([rangeStart, rangeEnd]);
    }
  });

  return ranges;
};
